export default "__VITE_ASSET__Vm5peC_I__"